import { render } from "./AppMain.vue?vue&type=template&id=623d5c32&scoped=true&ts=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=623d5c32&lang=scss&scoped=true"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d5c32"]])

export default __exports__